import React, { PropTypes } from 'react';
import CSSTransitionGroup from 'react-addons-css-transition-group';
import { Map, OrderedMap } from 'immutable';
import TextInput from 'components/TextInput';
import SelectInput from 'components/SelectInput';
import LanguageSelector from 'components/LanguageSelector';
import Card from 'components/Card';
import Button from 'components/Button';
import cx from './GoalsSearch.scss';

import TabFilter from './TabFilter';

const helpItems = Map(__('help_filter_options'));
const statusItems = Map(__('status_filter_options'));
const showItems = Map(__('show_goal_filter_options'));
const templateTypeItems = Map(__('template_type_items'));
const sortItems = Map(__('goals_sort_items'));

import withStyles from 'decorators/withStyles';

@withStyles(cx)
export default class GoalsSearch extends React.Component {

	static propTypes = {
		onChange: PropTypes.func.isRequired,
		filter: PropTypes.object,
		flux: PropTypes.object,
		categories: PropTypes.object,
		loading: PropTypes.bool,
		onReset: PropTypes.func.isRequired,
	};

	constructor(props) {
		super(props);

		this.state = {
			focused: false,
			expanded: false,
			progress: 0,
		};
	}

	render() {
		const { progress, expanded } = this.state;
		const { filter, categories } = this.props;

		return (
			<Card className={cx('main')}>
				<div
					ref="progress"
					className={cx('progress')}
					style={{
						opacity: progress === 0 ? 0 : 1,
						width: `${progress * 100}%`,
					}}
					/>

				<div className={cx('top', [filter.list_type])}>
					<TextInput
						className={cx('input')}
						onFocus={() => this.expand()}
						onChange={v => this.handleSearchChange('name', v)}
						value={filter.name}
						/>

					<div className={cx('lang')}>
						<LanguageSelector
							title={filter.list_type === 'goal' ? __('goal.lang') : __('template.lang')}
							value={filter.lang || []}
							onChange={v => this.handleSearchChange('lang', v)}
							/>
					</div>

					<div>
						{filter.list_type === 'template' &&
							<div className={cx('filter')}>
								<SelectInput
									mods={['transparent']}
									items={templateTypeItems}
									value={filter.type}
									onChange={v => this.handleSearchChange('type', v)}
									/>
							</div>
						}

						{!expanded &&
							<div>
								{filter.list_type === 'goal' &&
									<div className={cx('filter')}>
										<SelectInput
											mods={['transparent']}
											items={categories.reduce((memo, category) => {
												return memo.set(category.get('id'), category.get('name'));
											}, OrderedMap())}
											value={filter.category}
											onChange={v => this.handleSearchChange('category', v)}
											/>
									</div>
								}

								{filter.list_type === 'goal' &&
									<div className={cx('filter')}>
										<SelectInput
											mods={['transparent']}
											items={sortItems}
											value={filter.sort}
											onChange={v => this.handleSearchChange('sort', v)}
											/>
									</div>
								}

								{filter.list_type === 'goal' &&
									<div className={cx('filter')}>
										<SelectInput
											mods={['transparent']}
											items={helpItems}
											value={filter.help}
											onChange={v => this.handleSearchChange('help', v)}
											/>
									</div>
								}
							</div>
						}
					</div>
				</div>

				<CSSTransitionGroup
					transitionName="t-search-slide"
					transitionEnterTimeout={200}
					transitionLeaveTimeout={200}
				>
					{(expanded && filter.list_type === 'goal') &&
						<div className={cx('expanded')}>
							<section className={cx('col', ['main'])}>
								<label className={cx('lbl')}>{__('goal.show')}</label>
								<TabFilter
									items={showItems}
									value={filter.section}
									onChange={v => this.handleSearchChange('section', v)} />
							</section>
							<section className={cx('col')}>
								<label className={cx('lbl')}>{__('goal.category')}</label>
								<SelectInput
									mods={['transparent']}
									items={categories.reduce((memo, category) => {
										return memo.set(category.get('id'), category.get('name'));
									}, OrderedMap())}
									value={filter.category}
									onChange={v => this.handleSearchChange('category', v)}
									/>
							</section>

							<section className={cx('col', ['main'])}>
								<label className={cx('lbl')}>{__('sort')}</label>
								<TabFilter
									items={sortItems}
									value={filter.sort}
									onChange={v => this.handleSearchChange('sort', v)} />
							</section>
							<section className={cx('col')} />

							<section className={cx('col', ['main'])}>
								<label className={cx('lbl')}>{__('status')}</label>
								<TabFilter
									items={statusItems}
									value={filter.status || 'all'}
									onChange={v => this.handleSearchChange('status', v)} />
							</section>
							<section className={cx('col')} />

							<div className="clear"></div>
							<div className={cx('clear')}>
								<Button theme="gray" onClick={() => {this.wrap(); this.props.onReset;}}>
									{__('close')}
								</Button>
							</div>
						</div>
					}
				</CSSTransitionGroup>
			</Card>
		);
	}

	handleSearchChange(key, value) {
		this.props.onChange(key, value);
	}

	expand() {
		this.setState({ expanded: true });
	}

	wrap() {
		this.setState({ expanded: false });
	}

	componentDidMount() {
		// ends up progress
		this.refs.progress.addEventListener(
			'transitionend',
			() => this.setState({ progress: this.state.progress === 1 ? 0 : this.state.progress })
		);
	}

	componentWillUpdate(nextProps) {
		// faking progress
		if(nextProps.loading && !this.props.loading) {
			this.setState({ progress: 0.7 });
		} else if(!nextProps.loading && this.props.loading) {
			this.setState({ progress: 1 });
		}
	}

}



// WEBPACK FOOTER //
// ./src/react/components/GoalsSearch/GoalsSearch.js